import { AztecProduct } from 'types/models';
import { getSelectedPortion, updatePortionQuantity } from 'menu/utils';
import { QuantityField } from 'menu/components/MenuModal/ModalComponents';
import { useMenuModal } from 'contexts/MenuModalContext';

interface FooterQuantityFieldProps {
  aztecProduct: AztecProduct;
  updateAztecProduct: (product: AztecProduct) => void;
}

export const FooterQuantityField: React.FC<FooterQuantityFieldProps> = ({
  aztecProduct,
  updateAztecProduct,
}) => {
  const { breadcrumbs } = useMenuModal();
  const onPortionQuantityChange = (portionId: number, quantity: number) => {
    const updatedProduct = updatePortionQuantity(
      aztecProduct,
      portionId,
      quantity,
    );
    updateAztecProduct(updatedProduct);
  };

  const selectedPortion = getSelectedPortion(aztecProduct);

  if (!selectedPortion.quantity || breadcrumbs.length > 0) {
    return null;
  }

  return (
    <div className="menu-modal-quantity">
      <QuantityField
        quantity={selectedPortion.quantity}
        min={1}
        callbackArgs={[selectedPortion?.id]}
        onChange={onPortionQuantityChange}
        max={99}
      />
    </div>
  );
};
